import { SystemEvent } from '@mbrtargeting/metatag-shared-types/metatag-core';
import { triggerEvent } from '../loader/essentials/events.js';
import { MetaTag } from '../loader/essentials/init-metatag.js';
import { log } from '../loader/essentials/logger.js';
import { patchLegacyStuffToSDG } from './legacy.js';
import { MetaTagAdhesionUnitWatcher } from './modules/adhesion-unit-watcher/adhesion-unit-watcher.js';
import { AdslotController } from './modules/adslot-controller/adslot-controller.js';
import { FullPublisherAPI } from './modules/apis/full-publisher-api.js';
import { PublicAdvertisingApi } from './modules/apis/public-advertising-api.js';
import { PublicInfotoolAPI } from './modules/apis/public-infotool-api.js';
import { PublicWrapperApi } from './modules/apis/public-wrapper-api.js';
import { AudienceProject } from './modules/audienceproject/audienceproject.js';
import { MetaTagContentObjectWatcher } from './modules/content-object-watcher/content-object-watcher.js';
import { CssInjector } from './modules/css-injector/css-injector.js';
import { FeatureController } from './modules/feature-controller/feature-controller.js';
import { FormatController } from './modules/format-controller/format-controller.js';
import { RingierGamAdserver, StroeerGamAdserver } from './modules/gam-adserver/gam-adserver.js';
import { CanonicalUrlCollector } from './modules/generic-targeting/canonical-url.js';
import { CountryCodeTargeting } from './modules/generic-targeting/country-code-targeting.js';
import { GenericTargeting } from './modules/generic-targeting/generic-targeting.js';
import { MetaKeywordsCollector } from './modules/generic-targeting/meta-keyswords.js';
import { GlobalSettings } from './modules/global-settings/global-settings.js';
import { GlobalTargeting } from './modules/global-targeting/global-targeting.js';
import { IdStore } from './modules/idstore/idstore.js';
import { RecoverPrebidIds } from './modules/idstore/recover-prebid-ids.js';
import { LoadAdLibrary } from './modules/load-ad-library/load-ad-library.js';
import { MbrId } from './modules/mbrid/mbrid.js';
import { NativeBackfill } from './modules/native-backfill-demand-source/native-backfill.js';
import { NetIdTracking } from './modules/netid/netid-tracking.js';
import { NetId } from './modules/netid/netid.js';
import { PhaseController } from './modules/phase-controller/phase-controller.js';
import { SecondarySkyscraper } from './modules/secondary-skyscraper/secondary-skyscraper.js';
import { SpeedCurve } from './modules/speedcurve/speedcurve.js';
import { StorageHelper } from './modules/storage/storage-helper.js';
import { StroeerSponsorship } from './modules/stroeerssp/stroeerSponsorship.js';
import { StroeerSsp } from './modules/stroeerssp/stroeerssp.js';
import { UtiqTracking } from './modules/utiq/utiq-tracking.js';
import { Utiq } from './modules/utiq/utiq.js';
import { VastTagGenerator } from './modules/video/vast-tag-generator.js';
import { DoubleverifyTrackingAdSlotAddon } from './modules/viewability/doubleverify-tracking.js';
import { Yieldlove } from './modules/yieldlove/yieldlove.js';
import { ADHESION_UNIT_WATCHER, ADSLOT_CONTROLLER, ADVERTISING_API, AUDIENCE_PROJECT, CANONICAL_URL_COLLECTOR, CONTENT_OBJECT_WATCHER, COUNTRY_CODE_TARGETING, CSS_INJECTOR, DOUBLE_VERIFY_TRACKING_AD_SLOT_ADDON, FEATURE_CONTROLLER, FORMAT_CONTROLLER, FULL_PUBLISHER_API, GENERIC_TARGETING, GLOBAL_SETTINGS, GLOBAL_TARGETING, ID_STORE, LOAD_AD_LIBRARY, MBR_ID, META_KEYWORDS_COLLECTOR, NATIVE_BACKFILL, NET_ID, NET_ID_TRACKING, PHASE_CONTROLLER, PUBLIC_INFOTOOL_API, RECOVER_PREBID_IDS, RINGIER_GAM_ADSERVER, SECONDARY_SKYSCRAPER, SPEED_CURVE, STORAGE_HELPER, STROEER_GAM_ADSERVER, STROEER_SPONSORSHIP, STROEER_SSP, UTIQ, UTIQ_TRACKING, VAST_TAG_GENERATOR, WRAPPER_API, YIELDLOVE } from './token.js';

declare const SDG: MetaTag;

SDG.registerModule(GLOBAL_SETTINGS, GlobalSettings);
SDG.registerModule(CONTENT_OBJECT_WATCHER, MetaTagContentObjectWatcher);
SDG.registerModule(FORMAT_CONTROLLER, FormatController);
SDG.registerModule(FEATURE_CONTROLLER, FeatureController);
SDG.registerModule(ADHESION_UNIT_WATCHER, MetaTagAdhesionUnitWatcher);
SDG.registerModule(STORAGE_HELPER, StorageHelper);
SDG.registerModule(GLOBAL_TARGETING, GlobalTargeting);
SDG.registerModule(ID_STORE, IdStore);
SDG.registerModule(RECOVER_PREBID_IDS, RecoverPrebidIds);
SDG.registerModule(NET_ID_TRACKING, NetIdTracking);
SDG.registerModule(NET_ID, NetId);
SDG.registerModule(MBR_ID, MbrId);
SDG.registerModule(UTIQ_TRACKING, UtiqTracking);
SDG.registerModule(UTIQ, Utiq);
SDG.registerModule(GENERIC_TARGETING, GenericTargeting);
SDG.registerModule(META_KEYWORDS_COLLECTOR, MetaKeywordsCollector);
SDG.registerModule(CANONICAL_URL_COLLECTOR, CanonicalUrlCollector);
SDG.registerModule(STROEER_GAM_ADSERVER, StroeerGamAdserver);
SDG.registerModule(RINGIER_GAM_ADSERVER, RingierGamAdserver);
SDG.registerModule(STROEER_SSP, StroeerSsp);
SDG.registerModule(STROEER_SPONSORSHIP, StroeerSponsorship);
SDG.registerModule(YIELDLOVE, Yieldlove);
SDG.registerModule(NATIVE_BACKFILL, NativeBackfill);
SDG.registerModule(CSS_INJECTOR, CssInjector);
SDG.registerModule(ADSLOT_CONTROLLER, AdslotController);
SDG.registerModule(PHASE_CONTROLLER, PhaseController);
SDG.registerModule(VAST_TAG_GENERATOR, VastTagGenerator);
SDG.registerModule(PUBLIC_INFOTOOL_API, PublicInfotoolAPI);
SDG.registerModule(FULL_PUBLISHER_API, FullPublisherAPI);
SDG.registerModule(DOUBLE_VERIFY_TRACKING_AD_SLOT_ADDON, DoubleverifyTrackingAdSlotAddon);
SDG.registerModule(LOAD_AD_LIBRARY, LoadAdLibrary);
SDG.registerModule(ADVERTISING_API, PublicAdvertisingApi);
SDG.registerModule(WRAPPER_API, PublicWrapperApi);
SDG.registerModule(SPEED_CURVE, SpeedCurve);
SDG.registerModule(COUNTRY_CODE_TARGETING, CountryCodeTargeting);
SDG.registerModule(AUDIENCE_PROJECT, AudienceProject);
SDG.registerModule(SECONDARY_SKYSCRAPER, SecondarySkyscraper);

patchLegacyStuffToSDG();

triggerEvent(SystemEvent.SDG_CORE_FILE_LOADED, {});

//legacy for some publisher, namely SMB and OMS. See shared-types documentation for these events.
triggerEvent(SystemEvent.SDG_AD_SERVER_MODULE_LOADED, {});
triggerEvent(SystemEvent.SDG_CRITICAL_MODULES_LOADED, {});
triggerEvent(SystemEvent.SDG_WINDOW_LOAD_COMPLETE, {});

log.info('MetaTag2 Core - Version %s', [__METATAG_VERSION__]);
